module.exports = __webpack_public_path__ + "img/66363591d8aa2815.png";